<div v-if="pagination.hasNextPage && !isLoading.loading" class="text-center">
    <button 
        class="button primary"
        @click.prevent="loadNextPage()"
    >
        View more
    </button>
</div>
